import React, { useState } from "react";
import { Container, Grid, Stack } from "@mui/material";
import DebtorForm from "../components/DebtorForm";
import DebtorList from "../components/DebtorList";
import FinancePageHeader from "../components/finance/FinancePageHeader";
import DashboardLayout from "../components/Layout/DashboardLayout";
import { useAuth } from "../context/AuthContext";

const DebtorsPage = () => {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <DashboardLayout
      role={user?.role}
      activePage="/debtors"
      title="Gestion des débiteurs"
    >
      <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
        <Stack spacing={2.5}>
          <FinancePageHeader
            title="Gestion des débiteurs"
            subtitle="Enregistrez et consultez les débiteurs liés aux opérations de prêt de votre agence."
          />

          <Grid container spacing={2}>
            <Grid item xs={12} lg={5}>
              <DebtorForm onCreated={handleCreated} />
            </Grid>

            <Grid item xs={12} lg={7}>
              <DebtorList refreshKey={refreshKey} />
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default DebtorsPage;